import { configureStore } from "@reduxjs/toolkit";

import themeReducer from "features/theme/themeSlice";
import entityReducer from "features/entity/EntitySlice";
import setupReducer from "features/setup/SetupSlice";
import inputReducer from "features/asset/input/InputSlice";
import assetReducer from "features/asset/AssetSlice";
import screenReducer from "features/asset/screen/ScreenSlice";
import archivedReducer from "features/asset/archived/ArchivedSlice";
import assetGraphReducer from "features/asset/graph/GraphSlice";
import CartographyReducer from "features/map/CartographySlice";
import collectionNavReducer from "features/asset/collection/nav/NavSlice";
import collectionDropdownReducer from "features/asset/collection/dropdown/DropdownSlice";
import collectionSettingsReducer from "features/asset/collection/settings/SettingsSlice";
import collectionCreateReducer from "features/asset/collection/create/CreateSlice";
import collectionEditReducer from "features/asset/collection/edit/EditSlice";
import assetNavReducer from "features/asset/nav/NavSlice";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    entity: entityReducer,
    setup: setupReducer,
    input: inputReducer,
    asset: assetReducer,
    screen: screenReducer,
    archived: archivedReducer,
    assetGraph: assetGraphReducer,
    cartography: CartographyReducer,
    collectionNav: collectionNavReducer,
    collectionDropdown: collectionDropdownReducer,
    collectionSettings: collectionSettingsReducer,
    collectionCreate: collectionCreateReducer,
    collectionEdit: collectionEditReducer,
    assetNav: assetNavReducer,
  },
});
